import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import OrgApi from "./../../../API/OrgApi";
import CreateOrgReq from "./../../../Requests/Organizations/CreateOrgReq";
import OrganizationSelector from "./../../../components/OrganizationSelector";
import VersatileLoader from "../../../components/VersatileLoader";
import OrgCard from "./OrgCard";
import "./index.scss";
import Layout from "../../../Layouts/Layout";
import CreateFile from "../../../Requests/CloudFile/CreateFileReq";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

const Index = () => {
  const [name, setName] = useState("");
  const [parentOrgId, setParentOrgId] = useState(null);
  const [orgs, setOrgs] = useState(null);
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  function getOrgTree() {
    setLoading(true);
    OrgApi.GetOrgTree().then((res) => {
      if (res?.status?.success) {
        setOrgs(res.data);
        console.log(res.data);
        setLoading(false);
      } else {
      }
    });
  }

  useEffect(() => {
    getOrgTree();
  }, []);

  const createOrg = async () => {
    Swal.fire({
      icon: "info",
      title: "Creating Organization",
      text: "Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (!name) {
      Swal.fire({
        icon: "error",
        title: "Name is required",
        text: "Please enter Name",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    let req = new CreateOrgReq();

    req.name = name;
    if (parentOrgId) {
      req.parentOrgId = parentOrgId;
    }

    let res = await OrgApi.CreateOrg(req);

    if (logo) {
      const req02 = new CreateFile();
      let img = null;
      let downloadUrls = [];
      let filePaths = [];

      const storage = getStorage();

      const uploadAndGetData = async (file, type) => {
        const uniqueId = Date.now();
        const storageRef = ref(storage, `/SalesOrgLogo/${uniqueId}`);

        await uploadBytes(storageRef, file);

        const downloadURL = await getDownloadURL(storageRef);
        downloadUrls.push(downloadURL);

        filePaths.push(`/SalesOrgLogo/${uniqueId}`);
      };

      img = new CreateFile();

      await uploadAndGetData(logo, "image");
      img.name = logo.name;
      img.path = filePaths[0];
      img.url = downloadUrls[0];
      img.fileType = "image";
      img.extension = logo.name.split(".").pop();
      img.fileSize = logo.size.toString();
      img.caption = "Sales Org Logo";
      img.salesOrgId = res.data.id;

      console.log("img", img);

      let res02 = await OrgApi.UpdateOrgLogo(img);
    }

    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Organization Created",
        text: "Organization has been created",
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      });
      setName("");
      setParentOrgId(null);
      setLogo(null);
      OrgApi.GetOrgTree().then((res) => {
        if (res?.status?.success) {
          setOrgs(res.data);
        } else {
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };
  return (
    <Layout>
      <div className="manageOrganizations">
        <div className="filters">
          <h1>Create an Organization</h1>
          <div className="inputs">
            <input
              onChange={(e) => {
                setName(e.target.value);
              }}
              value={name}
              type="text"
              placeholder="Enter Name"
            />

            <OrganizationSelector
              className="org-selector"
              placeholder="Select Parent Organization"
              setUser={setParentOrgId}
              value={parentOrgId}
            />
            <input
              className=""
              style={{
                display: "None",
              }}
              type="file"
              id="fileUpload"
              onChange={(e) => setLogo(e.target.files[0])}
              placeholder="Upload Logo"
            />
            <label className="createOrganizationUpload" htmlFor="fileUpload">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {logo && (
                  <div
                    style={{
                      height: "40px",
                      width: "60px",
                    }}
                  >
                    <img
                      style={{ objectFit: "contain" }}
                      src={URL.createObjectURL(logo)}
                      className=""
                      alt="Uploaded Image"
                    />
                  </div>
                )}
                <p className="createOrganizationUploadText">
                  {logo ? logo.name : "Select File"}
                </p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="17"
                viewBox="0 0 14 17"
                fill="none"
              >
                <path
                  d="M5 12.9987H9C9.55 12.9987 10 12.5487 10 11.9987V6.99869H11.59C12.48 6.99869 12.93 5.91869 12.3 5.28869L7.71 0.698694C7.61749 0.60599 7.5076 0.532443 7.38662 0.482261C7.26565 0.43208 7.13597 0.40625 7.005 0.40625C6.87403 0.40625 6.74435 0.43208 6.62338 0.482261C6.5024 0.532443 6.39251 0.60599 6.3 0.698694L1.71 5.28869C1.08 5.91869 1.52 6.99869 2.41 6.99869H4V11.9987C4 12.5487 4.45 12.9987 5 12.9987ZM1 14.9987H13C13.55 14.9987 14 15.4487 14 15.9987C14 16.5487 13.55 16.9987 13 16.9987H1C0.45 16.9987 0 16.5487 0 15.9987C0 15.4487 0.45 14.9987 1 14.9987Z"
                  fill="#2761D0"
                />
              </svg>
            </label>
            <div className="button-wrapper">
              <button
                className={"w-full sm:w-fit"}
                onClick={() => {
                  createOrg();
                }}
              >
                Create
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="spinner">
            <VersatileLoader size="large" color="var(--color-primary)" />
          </div>
        ) : (
          <div className="orgGraphs">
            {orgs &&
              orgs.map((org, index) => {
                return (
                  <OrgCard getOrgTree={getOrgTree} key={index} org={org} />
                );
              })}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Index;
